// extracted by mini-css-extract-plugin
export default {"root":"subjectIcon_root__TgNLV","subjectImage":"subjectIcon_subjectImage__A1Y2N","icon":"subjectIcon_icon__BdIDX"};